import { ITimetableDetail, ITimetableSchedule } from 'src/api/getTimetable';
import { ITimetableEntityGroup } from './groupSchedulesByEntity';
import { getDefaultEntity, getScheduleTrack, getTrack } from './helpers';
import { RemoveScheduleResult } from './reassignToDefault';
import { removeEntityBlocks } from './removeEntityBlocks';
import { removeScheduleBlocks } from './removeScheduleBlocks';

export type RemovalTarget =
  | { kind: 'timeslot'; schedule: ITimetableSchedule }
  | { kind: 'entity'; group: ITimetableEntityGroup };

export const buildRemovalBlocks = (timetable: ITimetableDetail, target: RemovalTarget): RemoveScheduleResult => {
  if (target.kind === 'timeslot') {
    const { schedule } = target;
    return removeScheduleBlocks(timetable.schedules, schedule, getDefaultEntity(timetable, getScheduleTrack(schedule)));
  }
  const { entityType, entityId } = target.group;
  const track = getTrack(entityType);
  return removeEntityBlocks(timetable.schedules, track, entityId, getDefaultEntity(timetable, track));
};
